<header class="header_menu">
  <a class="logo" routerLink="/">
    <img
      src="../../../assets/imagens/logo_foundation_2.svg"
      class="foundation_priest_logo"
      alt=""
    />
  </a>

  <button
    aria-label="menu"
    mat-icon-button
    class="hamburguer_menu"
    (click)="toggleNav()"
  >
    <i icon="menu"></i>
  </button>

  <div class="menu_main" [ngClass]="{hidden}">
    <div class="header_menu_nav">
      <img
        src="../../../assets/imagens/logo_priest.svg"
        class="foundation_priest_logo"
        alt=""
      />

      <button
        aria-label="menu"
        mat-icon-button
        class="hamburguer_menu"
        (click)="toggleNav()"
      >
        <i icon="x_mark"></i>
      </button>
    </div>

    <div class="list">
      <button mat-button class="button_menu" [matMenuTriggerFor]="fundation">
        <span class="menu_header">A Fundação</span>
      </button>
      <mat-menu #fundation="matMenu" yPosition="below">
        <div class="buttons">
          <button (click)="scrollTo('page_main', 'foundation')" mat-menu-item>
            Carta do Presidente
          </button>
          <button (click)="scrollTo('second_page', 'foundation')" mat-menu-item>
            Missão Institucional
          </button>
          <button (click)="scrollTo('third_page', 'foundation')" mat-menu-item>
            Biografia
          </button>
          <button (click)="scrollTo('fourth_page', 'foundation')" mat-menu-item>
            A PUC-Rio
          </button>
          <button (click)="scrollTo('fifth_page', 'foundation')" mat-menu-item>
            A FPLF e a PUC-Rio
          </button>
          <button (click)="scrollTo('six_page', 'foundation')" mat-menu-item>
            A Fundação
          </button>
          <button
            (click)="scrollTo('seven_page', 'inovar_group')"
            mat-menu-item
          >
            Núcleo INOVAR
          </button>
        </div>
      </mat-menu>

      <button mat-button class="button_menu" [matMenuTriggerFor]="instituction">
        <span class="menu_header">Institucional</span>
      </button>
      <mat-menu #instituction="matMenu" yPosition="below">
        <div class="buttons">
          <button
            (click)="scrollTo('page_main', 'institutional')"
            mat-menu-item
          >
            Conceito Jurídico
          </button>
          <button
            (click)="scrollTo('second_page', 'institutional')"
            mat-menu-item
          >
            Ata da Instituição
          </button>
          <button
            (click)="scrollTo('third_page', 'institutional')"
            mat-menu-item
          >
            Instalações
          </button>
        </div>
      </mat-menu>

      <button mat-button class="button_menu" [matMenuTriggerFor]="midias">
        <span class="menu_header"> Mídias </span>
      </button>
      <mat-menu #midias="matMenu" yPosition="below">
        <div class="buttons">
          <button (click)="scrollTo('page_main', 'midia')" mat-menu-item>
            Video Institucional
          </button>
          <button (click)="scrollTo('second_page', 'midia')" mat-menu-item>
            Galeria Institucional
          </button>
        </div>
      </mat-menu>

      <!-- <button mat-button class="button_menu" (click)="toggleNav()" routerLink="/fourty-years">
        <span class="menu_header">40 Anos</span>
      </button> -->

      <!-- <button mat-button class="button_menu" (click)="toggleNav()" routerLink="/mostracultural">
        <span class="menu_header">Edital</span>
      </button> -->

      <a
        href="http://www.fplf.org.br/extrato-web/index.html"
        id="button_access"
        mat-flat-button
        color="accent"
        rel="noopener noreferrer"
        target="_blank"
      >
        <span class="menu_button_header">Acessar portal</span>
      </a>
    </div>
  </div>
</header>

<router-outlet></router-outlet>

<app-footer></app-footer>
